export default "__VITE_ASSET__df6a9d5c__"